export default "__VITE_ASSET__Di3p_Ic___"